import React from 'react';
import { Message } from 'semantic-ui-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import './ResultRenderer.css';

function CustomResultRenderer(props) {
  const {
    results, isShowResult, handleScroll, handleResultSelect, translate
  } = props;
  const options = results.map((item) => {
    return (
      <div className="result" key={item.id} onMouseDown={(e) => { return handleResultSelect(e, item); }}>
        <Message className="content">{item.name}</Message>
      </div>
    );
  });
  return (
    <div
      className={cx('results custom', {
        visible: isShowResult,
      })}
    >
      <Scrollbars
        renderTrackHorizontal={() => {
          return <div />;
        }}
        renderThumbHorizontal={() => {
          return <div />;
        }}
        autoHeight
        autoHeightMin={0}
        autoHeightMax={210}
        onScroll={handleScroll}
      >
        {options.length !== 0 ? (options) : (<Message className="empty"><Message.Header>{translate('knowledgebase.message.no_results_found')}</Message.Header></Message>)}
      </Scrollbars>
    </div>
  );
}

export default CustomResultRenderer;
